module.exports = __webpack_public_path__ + "static/media/Kaitlin Yang Resume.1c06c8c5.pdf";